import React from "react"

import {
  MenuItemAnchor,
  MenuItemLogo,
  MenuItemLink,
  MenuItemActu,
} from "../MenuItem/MenuItem"

import "./Menu.css"

import logo from "./logo.png"

const Menu = ({ onClickActu, isActive }) => {
  return (
    <nav className="nav">
      <ul>
        <MenuItemActu
          className="actualites"
          text="Actualités"
          onClick={onClickActu}
          isActive={isActive}
        />
        <MenuItemAnchor
          className="brasserie"
          text="Brasserie"
          anchor="#la-brasserie"
        />
        <MenuItemAnchor
          className="lesbieres"
          text="Bières"
          anchor="#les-bieres"
        />
        <MenuItemAnchor
          className="pointsdevente"
          text="Points de vente"
          anchor="#les-points-de-vente"
        />
        <MenuItemLogo logo={logo} className="logo" anchor="#accueil" />
        <MenuItemAnchor className="contact" text="Contact" anchor="#contact" />
        <MenuItemLink className="playlist" text="Playlist" />
        <MenuItemLink
          className="facebook"
          text="Facebook"
          url="https://www.facebook.com/BIERESLEBAIGNEUR/"
        />
        <MenuItemLink
          className="instagram"
          text="Instagram"
          url="https://www.instagram.com/brasseriedubaigneur/"
        />
      </ul>
    </nav>
  )
}

export default Menu



// WEBPACK FOOTER //
// ./src/Components/Menu/Menu.js